import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { QRCodeCanvas } from "qrcode.react";
import { X, Printer } from "@phosphor-icons/react";

export default function QrPosterSheet({ onClose }) {
  const [assets, setAssets] = useState([]);
  const gridRef = useRef(null);

  useEffect(() => {
    api.get("/assets").then(({ data }) =>
      setAssets([...data].sort((a, b) => (a.asset_no || "").localeCompare(b.asset_no || "")))
    ).catch(() => {});
  }, []);

  const print = () => {
    const cards = [...(gridRef.current?.querySelectorAll("[data-poster]") || [])].map((el) => {
      const canvas = el.querySelector("canvas");
      const img = canvas ? `<img src="${canvas.toDataURL("image/png")}" width="150" height="150" />` : "";
      return `<div class="card">
        <div class="no">${el.dataset.assetNo}</div>
        <div class="type">${el.dataset.assetType || "&nbsp;"}</div>
        ${img}
        <div class="sub">Scan to submit a hire docket</div>
        <div class="sub">Asset PIN</div>
        <div class="pin">${el.dataset.pin}</div>
      </div>`;
    }).join("");
    const w = window.open("", "_blank", "width=900,height=700");
    if (!w) return;
    w.document.write(`<html><head><title>EQUIPR — Asset QR Posters</title><style>
      body{font-family:Montserrat,Arial,sans-serif;color:#0c100f;margin:10mm}
      h1{font-size:16px;margin:0 0 8px}
      .grid{display:grid;grid-template-columns:repeat(3,1fr);gap:6mm}
      .card{border:2px solid #0c100f;padding:10px;text-align:center;page-break-inside:avoid}
      .no{font-size:18px;font-weight:800} .type{font-size:11px;color:#555;margin-bottom:6px}
      .sub{font-size:10px;color:#555;margin-top:4px}
      .pin{font-size:24px;font-weight:800;letter-spacing:5px}
    </style></head><body><h1>EQUIPR Civil — Asset Docket QR + PIN</h1><div class="grid">${cards}</div></body></html>`);
    w.document.close();
    w.focus();
    setTimeout(() => { w.print(); w.close(); }, 400);
  };

  return (
    <div className="fixed inset-0 z-[60] bg-[rgba(26,26,26,0.42)] flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-surface-panel border border-border-warm rounded-[14px] overflow-hidden shadow-modal w-full max-w-4xl max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="qr-poster-sheet">
        <div className="flex items-center justify-between px-5 py-3 bg-equipr-black text-white shrink-0">
          <h3 className="font-bold text-sm">Asset QR Posters — {assets.length} assets</h3>
          <div className="flex items-center gap-3">
            <button onClick={print} data-testid="qr-poster-print"
              className="h-8 px-3 bg-equipr-yellow text-equipr-black text-xs font-bold rounded-none hover:bg-equipr-yellow-dark inline-flex items-center gap-1.5">
              <Printer size={14} weight="bold" /> Print all
            </button>
            <button onClick={onClose} data-testid="qr-poster-close"><X size={18} /></button>
          </div>
        </div>
        <div ref={gridRef} className="flex-1 overflow-auto p-5 grid grid-cols-3 gap-4">
          {assets.map((a) => (
            <div key={a.id} data-poster data-asset-no={a.asset_no} data-asset-type={a.asset_type || ""} data-pin={a.docket_pin || "——"}
              className="border-2 border-equipr-black p-3 text-center" data-testid={`qr-poster-${a.asset_no}`}>
              <div className="font-extrabold text-equipr-black">{a.asset_no}</div>
              <div className="text-[11px] text-gray-500 mb-2">{a.asset_type || "\u00a0"}</div>
              <div className="flex justify-center">
                <QRCodeCanvas value={`${window.location.origin}/docket?asset=${a.id}`} size={110} level="M" includeMargin />
              </div>
              <div className="text-[10px] text-gray-500 mt-1">Asset PIN</div>
              <div className="text-lg font-extrabold tracking-[0.3em]">{a.docket_pin || "——"}</div>
            </div>
          ))}
          {assets.length === 0 && <p className="col-span-3 text-center text-gray-400 text-sm py-10">Loading assets…</p>}
        </div>
      </div>
    </div>
  );
}
